import { stringifyCsv } from '@neo.tax/shared';

const HEADERS = ['business_component_name', 'description', 'keywords'];

export const HEADERS_STRINGIFIED = stringifyCsv([HEADERS]);

export const EXAMPLE_DATA_STRINGIFIED = stringifyCsv([
  HEADERS,
  [
    'Payments Platform',
    'Ledger and settlement services that move money between customers and banks.',
    'payments; ledger; settlement; reconciliation',
  ],
  [
    'Search Ranking',
    'Relevance models that order search results for each query.',
    'ranking; relevance; embeddings; recall',
  ],
  ['Mobile App', 'The iOS and Android apps customers use to manage their accounts.', 'ios; android; mobile'],
]);
